var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_7990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9306 31.3237C16.1421 33.4882 17.5291 36.0956 18.0086 38.608C18.109 39.1341 17.3017 39.959 16.7734 39.8699C14.2514 39.4445 11.6148 38.1137 9.40335 35.9493C7.19188 33.7849 5.80482 31.1775 5.32531 28.6651C5.22492 28.1389 6.03227 27.314 6.56051 27.4031C9.08257 27.8285 11.7191 29.1592 13.9306 31.3237Z",
    fill: "url(#paint0_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9306 31.3237C16.1421 33.4882 17.5291 36.0956 18.0086 38.608C18.109 39.1341 17.3017 39.959 16.7734 39.8699C14.2514 39.4445 11.6148 38.1137 9.40335 35.9493C7.19188 33.7849 5.80482 31.1775 5.32531 28.6651C5.22492 28.1389 6.03227 27.314 6.56051 27.4031C9.08257 27.8285 11.7191 29.1592 13.9306 31.3237Z",
    fill: "url(#paint1_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9295 26.1974C18.7027 29.6629 19.3154 33.3273 18.8837 36.5159C18.7933 37.1836 17.5005 37.8451 16.906 37.5277C14.0675 36.0126 11.4541 33.3718 9.68093 29.9063C7.90779 26.4409 7.29495 22.7764 7.72671 19.5879C7.81711 18.9202 9.10985 18.2587 9.70436 18.5761C12.5428 20.0912 15.1562 22.7319 16.9295 26.1974Z",
    fill: "url(#paint2_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69312 23.3855C7.92743 25.5282 8.58057 27.7554 9.68106 29.9062C11.4543 33.3717 14.0676 36.0125 16.9062 37.5276C17.5006 37.8448 18.7933 37.1834 18.8838 36.5157C19.3156 33.3273 18.7028 29.6628 16.9296 26.1973C15.8855 24.1566 14.5498 22.4024 13.0485 20.9951L7.69312 23.3855Z",
    fill: "url(#paint3_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0694 31.3237C34.8579 33.4882 33.4708 36.0956 32.9913 38.608C32.8909 39.1341 33.6983 39.959 34.2265 39.8699C36.7486 39.4445 39.3852 38.1137 41.5966 35.9493C43.8081 33.7849 45.1952 31.1775 45.6747 28.6651C45.7751 28.1389 44.9677 27.314 44.4395 27.4031C41.9174 27.8285 39.2808 29.1592 37.0694 31.3237Z",
    fill: "url(#paint4_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0694 31.3237C34.8579 33.4882 33.4708 36.0956 32.9913 38.608C32.8909 39.1341 33.6983 39.959 34.2265 39.8699C36.7486 39.4445 39.3852 38.1137 41.5966 35.9493C43.8081 33.7849 45.1952 31.1775 45.6747 28.6651C45.7751 28.1389 44.9677 27.314 44.4395 27.4031C41.9174 27.8285 39.2808 29.1592 37.0694 31.3237Z",
    fill: "url(#paint5_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0705 26.1974C32.2972 29.6629 31.6845 33.3273 32.1162 36.5159C32.2066 37.1836 33.4994 37.8451 34.0939 37.5277C36.9324 36.0126 39.5459 33.3718 41.319 29.9063C43.0921 26.4409 43.705 22.7764 43.2732 19.5879C43.1828 18.9202 41.8901 18.2587 41.2956 18.5761C38.4571 20.0912 35.8437 22.7319 34.0705 26.1974Z",
    fill: "url(#paint6_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3069 23.3855C43.0726 25.5282 42.4195 27.7554 41.319 29.9062C39.5458 33.3717 36.9324 36.0125 34.0939 37.5276C33.4995 37.8448 32.2067 37.1834 32.1162 36.5157C31.6845 33.3273 32.2972 29.6628 34.0705 26.1973C35.1146 24.1566 36.4503 22.4024 37.9515 20.9951L43.3069 23.3855Z",
    fill: "url(#paint7_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 49.9999C34.1105 49.9999 41.0908 43.0197 41.0908 34.4091C41.0908 25.7986 34.1105 18.8184 25.5 18.8184C16.8894 18.8184 9.90918 25.7986 9.90918 34.4091C9.90918 43.0197 16.8894 49.9999 25.5 49.9999Z",
    fill: "url(#paint8_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 46.8359C32.3632 46.8359 37.9269 41.2721 37.9269 34.4089C37.9269 27.5457 32.3632 21.9819 25.5 21.9819C18.6367 21.9819 13.073 27.5457 13.073 34.4089C13.073 41.2721 18.6367 46.8359 25.5 46.8359Z",
    fill: "url(#paint9_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 45.078C31.392 45.078 36.1686 40.3015 36.1686 34.4094C36.1686 28.5172 31.392 23.7407 25.4999 23.7407C19.6078 23.7407 14.8313 28.5172 14.8313 34.4094C14.8313 40.3015 19.6078 45.078 25.4999 45.078Z",
    fill: "url(#paint10_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90918 34.409C9.90918 43.0196 16.8894 49.9998 25.5 49.9998C34.1106 49.9998 41.0908 43.0196 41.0908 34.409C41.0908 34.3485 41.0892 34.2884 41.0885 34.228H9.91143C9.91075 34.2884 9.90918 34.3485 9.90918 34.409Z",
    fill: "url(#paint11_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8726 49.3776C34.7852 47.9448 38.6945 44.16 40.2997 39.3235L32.7062 31.73L30.9944 31.814L26.3742 27.1938L20.7433 40.2483L29.8726 49.3776Z",
    fill: "url(#paint12_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8929 31.0212L28.8353 30.2825C28.5509 30.2138 28.3024 30.0413 28.1384 29.799L26.3758 27.1936C26.1626 26.8785 25.836 26.7094 25.5 26.6821C25.1639 26.7094 24.8372 26.8785 24.6241 27.1936L22.8615 29.799C22.6976 30.0413 22.4491 30.2138 22.1646 30.2825L19.107 31.0212C18.2776 31.2216 17.932 32.2115 18.4563 32.8847L20.3896 35.3661C20.5694 35.5969 20.6566 35.8865 20.6341 36.1783L20.3918 39.3145C20.3261 40.1652 21.1607 40.7999 21.963 40.5091L24.9203 39.4373C25.1072 39.3696 25.3065 39.3521 25.5 39.3821C25.6935 39.3522 25.8927 39.3697 26.0796 39.4373L29.0369 40.5091C29.8391 40.7998 30.6738 40.1652 30.6081 39.3145L30.3658 36.1783C30.3433 35.8865 30.4305 35.5969 30.6103 35.3661L32.5436 32.8847C33.0679 32.2115 32.7223 31.2216 31.8929 31.0212Z",
    fill: "url(#paint13_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0796 39.4373L29.037 40.5091C29.8391 40.7998 30.6738 40.1652 30.6081 39.3145L30.3659 36.1783C30.3433 35.8865 30.4306 35.5969 30.6104 35.3661L32.5436 32.8847C33.068 32.2116 32.7224 31.2216 31.8929 31.0212L28.8354 30.2825C28.551 30.2138 28.3024 30.0413 28.1384 29.799L26.3759 27.1936C26.1626 26.8785 25.8361 26.7094 25.5 26.6821V39.3821C25.6935 39.3521 25.8928 39.3696 26.0796 39.4373Z",
    fill: "url(#paint14_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8929 31.0214L28.8354 30.2827C28.731 30.2575 28.6316 30.218 28.5393 30.1665L20.745 40.2482C21.0508 40.5437 21.5121 40.6728 21.963 40.5093L24.9204 39.4376C25.1073 39.3698 25.3066 39.3524 25.5 39.3824C25.6935 39.3525 25.8927 39.3699 26.0796 39.4376L29.037 40.5093C29.8391 40.8 30.6738 40.1654 30.6081 39.3147L30.3659 36.1786C30.3433 35.8868 30.4306 35.5972 30.6104 35.3663L32.5436 32.8849C33.0679 32.2117 32.7224 31.2218 31.8929 31.0214Z",
    fill: "url(#paint15_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.107 31.0214L22.1646 30.2827C22.269 30.2575 22.3684 30.218 22.4606 30.1665L30.255 40.2482C29.9492 40.5437 29.4879 40.6728 29.0369 40.5093L26.0796 39.4376C25.8927 39.3698 25.6934 39.3524 25.5 39.3824C25.3064 39.3525 25.1072 39.3699 24.9203 39.4376L21.963 40.5093C21.1608 40.8 20.3261 40.1654 20.3918 39.3147L20.6341 36.1786C20.6566 35.8868 20.5694 35.5972 20.3896 35.3663L18.4563 32.8849C17.932 32.2117 18.2776 31.2218 19.107 31.0214Z",
    fill: "url(#paint16_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2932 31.73C18.1478 32.0966 18.1827 32.5336 18.4563 32.8849L20.3895 35.3663C20.5694 35.5971 20.6566 35.8867 20.6341 36.1785L20.3918 39.3147C20.3261 40.1654 21.1607 40.8001 21.963 40.5093L24.9203 39.4375C25.1072 39.3698 25.3065 39.3523 25.4999 39.3823C25.6935 39.3524 25.8927 39.3699 26.0795 39.4375L29.0369 40.5093C29.8391 40.8 30.6738 40.1654 30.6081 39.3147L30.3658 36.1785C30.3533 36.0166 30.3757 35.8558 30.4279 35.7049L18.2932 31.73Z",
    fill: "url(#paint17_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7079 31.73C32.8533 32.0966 32.8185 32.5336 32.5448 32.8849L30.6116 35.3663C30.4318 35.5971 30.3445 35.8867 30.3671 36.1785L30.6093 39.3147C30.675 40.1654 29.8403 40.8001 29.0381 40.5093L26.0808 39.4375C25.8939 39.3698 25.6946 39.3523 25.5012 39.3823C25.3077 39.3524 25.1084 39.3699 24.9216 39.4375L21.9642 40.5093C21.1621 40.8 20.3274 40.1654 20.393 39.3147L20.6353 36.1785C20.6478 36.0166 20.6254 35.8558 20.5732 35.7049L32.7079 31.73Z",
    fill: "url(#paint18_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.8184C25.4353 18.8184 25.3711 18.82 25.3066 18.8208L22.9005 21.2269L40.4653 38.7917C40.8718 37.4013 41.0908 35.9308 41.0908 34.409C41.0908 25.7986 34.1106 18.8184 25.5 18.8184Z",
    fill: "url(#paint19_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0883 0.32666V8.56196L25.5 17.9737L34.9118 8.56196V0.32666H16.0883Z",
    fill: "url(#paint20_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0883 0.32666V2.8896L25.4686 12.2699C25.4859 12.2872 25.5141 12.2872 25.5315 12.2699L34.9118 2.8896V0.32666H16.0883Z",
    fill: "url(#paint21_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.7528C25.112 13.7528 24.724 13.6051 24.4287 13.3097L16.0883 4.96924V8.56198L25.5 17.9737L34.9118 8.56198V4.96924L26.5713 13.3097C26.276 13.605 25.8881 13.7528 25.5 13.7528Z",
    fill: "url(#paint22_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0883 0.32666V2.8896L25.4686 12.2699C25.4859 12.2872 25.5141 12.2872 25.5315 12.2699L34.9118 2.8896V0.32666H16.0883Z",
    fill: "url(#paint23_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.7528C25.112 13.7528 24.724 13.6051 24.4287 13.3097L16.0883 4.96924V8.56198L25.5 17.9737L34.9118 8.56198V4.96924L26.5713 13.3097C26.276 13.605 25.8881 13.7528 25.5 13.7528Z",
    fill: "url(#paint24_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.7528C25.8881 13.7528 26.276 13.6051 26.5713 13.3097L34.9118 4.96924V8.56198L25.5 17.9737L16.0883 8.56198V4.96924L24.4287 13.3097C24.724 13.605 25.1121 13.7528 25.5 13.7528Z",
    fill: "url(#paint25_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4679 15.8361L16.4587 7.82691C15.8581 7.22632 14.8843 7.22632 14.2837 7.82691C13.6831 8.42749 13.6831 9.40132 14.2837 10.0019L25.5 21.2184L36.7163 10.002C37.3169 9.40142 37.3169 8.42759 36.7163 7.827C36.1158 7.22642 35.1419 7.22642 34.5413 7.827L26.5321 15.8362C25.962 16.4062 25.0379 16.4062 24.4679 15.8361Z",
    fill: "url(#paint26_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2837 7.84514L24.319 17.8805C24.9713 18.5328 26.0288 18.5328 26.6811 17.8805L36.7164 7.84514C36.7193 7.8422 36.7217 7.83897 36.7246 7.83602C36.7218 7.83308 36.7193 7.82985 36.7164 7.82691C36.1158 7.22632 35.142 7.22632 34.5414 7.82691L26.5322 15.8361C25.9622 16.4061 25.038 16.4061 24.468 15.8361L16.4587 7.82691C15.8582 7.22632 14.8843 7.22632 14.2837 7.82691C14.2808 7.82985 14.2785 7.83308 14.2755 7.83602C14.2784 7.83897 14.2807 7.8422 14.2837 7.84514Z",
    fill: "url(#paint27_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 21.2183L33.4175 13.3008H29.0674L26.532 15.8362C25.962 16.4062 25.0378 16.4062 24.4678 15.8362L21.9324 13.3008H17.5823L25.4999 21.2183Z",
    fill: "url(#paint28_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5195 20.2381L25.4999 21.2185L35.5417 11.1768H31.1916L26.5321 15.8363C25.9787 16.3897 25.0925 16.4041 24.5195 15.883V20.2381Z",
    fill: "url(#paint29_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 22.3037C27.5304 22.3037 29.1763 20.6578 29.1763 18.6274C29.1763 16.5971 27.5304 14.9512 25.5 14.9512C23.4697 14.9512 21.8237 16.5971 21.8237 18.6274C21.8237 20.6578 23.4697 22.3037 25.5 22.3037Z",
    fill: "url(#paint30_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.7353C26.664 20.7353 27.6076 19.7917 27.6076 18.6277C27.6076 17.4636 26.664 16.52 25.5 16.52C24.336 16.52 23.3923 17.4636 23.3923 18.6277C23.3923 19.7917 24.336 20.7353 25.5 20.7353Z",
    fill: "url(#paint31_linear_4466_7990)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3335 3.6601H14.6664C14.0439 3.6601 13.5392 3.15539 13.5392 2.53284V1.12725C13.5392 0.504706 14.0439 0 14.6664 0H36.3336C36.956 0 37.4608 0.504706 37.4608 1.12725V2.53294C37.4608 3.15549 36.9561 3.6601 36.3335 3.6601Z",
    fill: "url(#paint32_linear_4466_7990)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4466_7990",
    x1: 8.10488,
    y1: 28.0939,
    x2: 11.31,
    y2: 33.1421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4466_7990",
    x1: 8.55579,
    y1: 32.5393,
    x2: 11.9758,
    y2: 33.7872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4466_7990",
    x1: 13.5874,
    y1: 22.7111,
    x2: 13.138,
    y2: 30.6499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4466_7990",
    x1: 12.5671,
    y1: 26.7365,
    x2: 14.506,
    y2: 30.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4466_7990",
    x1: 42.8873,
    y1: 28.1077,
    x2: 39.6821,
    y2: 33.1559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4466_7990",
    x1: 42.4363,
    y1: 32.553,
    x2: 39.0163,
    y2: 33.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4466_7990",
    x1: 37.4047,
    y1: 22.725,
    x2: 37.854,
    y2: 30.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4466_7990",
    x1: 38.4251,
    y1: 26.7503,
    x2: 36.4861,
    y2: 30.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4466_7990",
    x1: 15.8876,
    y1: 24.7968,
    x2: 32.3304,
    y2: 41.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4466_7990",
    x1: 33.5711,
    y1: 42.4801,
    x2: 17.1933,
    y2: 26.1022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4466_7990",
    x1: 17.7441,
    y1: 26.6536,
    x2: 30.5105,
    y2: 39.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4466_7990",
    x1: 25.5,
    y1: 38.9706,
    x2: 25.5,
    y2: 49.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4466_7990",
    x1: 34.8375,
    y1: 42.5119,
    x2: 21.9616,
    y2: 34.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4466_7990",
    x1: 22.2523,
    y1: 31.4456,
    x2: 28.1088,
    y2: 37.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4466_7990",
    x1: 29.0091,
    y1: 33.0423,
    x2: 20.9147,
    y2: 36.3886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4466_7990",
    x1: 26.8957,
    y1: 35.915,
    x2: 22.4641,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4466_7990",
    x1: 24.1043,
    y1: 35.915,
    x2: 28.5358,
    y2: 34.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4466_7990",
    x1: 24.2028,
    y1: 36.1373,
    x2: 27.0516,
    y2: 31.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4466_7990",
    x1: 26.5787,
    y1: 35.5591,
    x2: 26.3414,
    y2: 31.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4466_7990",
    x1: 33.1828,
    y1: 27.8227,
    x2: 27.1697,
    y2: 17.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4466_7990",
    x1: 26.1973,
    y1: 5.55637,
    x2: 30.0698,
    y2: 11.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4466_7990",
    x1: 22.3346,
    y1: -2.02167,
    x2: 34.3608,
    y2: 11.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4466_7990",
    x1: 19.7799,
    y1: 0.206101,
    x2: 31.806,
    y2: 13.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4466_7990",
    x1: 25.5,
    y1: 6.5195,
    x2: 25.5,
    y2: 3.28088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4466_7990",
    x1: 29.225,
    y1: 10.4905,
    x2: 30.8986,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4466_7990",
    x1: 21.775,
    y1: 10.4905,
    x2: 20.1015,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4466_7990",
    x1: 33.9986,
    y1: 17.4131,
    x2: 13.8947,
    y2: -2.69084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4466_7990",
    x1: 25.5,
    y1: 8.00671,
    x2: 25.5,
    y2: 21.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4466_7990",
    x1: 25.4999,
    y1: 15.9805,
    x2: 25.4999,
    y2: 20.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4466_7990",
    x1: 30.1339,
    y1: 13.4247,
    x2: 27.3888,
    y2: 16.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4466_7990",
    x1: 23.3922,
    y1: 16.5196,
    x2: 28.5912,
    y2: 21.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4466_7990",
    x1: 26.9951,
    y1: 20.1228,
    x2: 24.4215,
    y2: 17.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4466_7990",
    x1: 25.5,
    y1: 1.11108,
    x2: 25.5,
    y2: 3.15402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_7990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.73559af38d1528fb1ecd32706ab45de8.svg";
export { ForwardRef as ReactComponent };